// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const ShoebillSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'shoebill-idle',
    metadata: {
      frames: {
        'shoebill-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-idle-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-idle-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-idle-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-idle-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill/idle.png',
        size: {
          w: 320,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'shoebill-idle': [
          'shoebill-idle-0',
          'shoebill-idle-1',
          'shoebill-idle-2',
          'shoebill-idle-3',
          'shoebill-idle-4',
        ],
      },
    },
  },
  {
    name: 'shoebill-walk',
    metadata: {
      frames: {
        'shoebill-walk-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-7': {
          frame: {
            x: 448,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-8': {
          frame: {
            x: 512,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-9': {
          frame: {
            x: 576,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-10': {
          frame: {
            x: 640,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-walk-11': {
          frame: {
            x: 704,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill/walk.png',
        size: {
          w: 768,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'shoebill-walk': [
          'shoebill-walk-0',
          'shoebill-walk-1',
          'shoebill-walk-2',
          'shoebill-walk-3',
          'shoebill-walk-4',
          'shoebill-walk-5',
          'shoebill-walk-6',
          'shoebill-walk-7',
          'shoebill-walk-8',
          'shoebill-walk-9',
          'shoebill-walk-10',
          'shoebill-walk-11',
        ],
      },
    },
  },
  {
    name: 'shoebill-eggLays',
    metadata: {
      frames: {
        'shoebill-eggLays-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-7': {
          frame: {
            x: 448,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-8': {
          frame: {
            x: 512,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-9': {
          frame: {
            x: 576,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-10': {
          frame: {
            x: 640,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-11': {
          frame: {
            x: 704,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-12': {
          frame: {
            x: 768,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-eggLays-13': {
          frame: {
            x: 832,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill/eggLays.png',
        size: {
          w: 896,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'shoebill-eggLays': [
          'shoebill-eggLays-0',
          'shoebill-eggLays-1',
          'shoebill-eggLays-2',
          'shoebill-eggLays-3',
          'shoebill-eggLays-4',
          'shoebill-eggLays-5',
          'shoebill-eggLays-6',
          'shoebill-eggLays-7',
          'shoebill-eggLays-8',
          'shoebill-eggLays-9',
          'shoebill-eggLays-10',
          'shoebill-eggLays-11',
          'shoebill-eggLays-12',
          'shoebill-eggLays-13',
        ],
      },
    },
  },
  {
    name: 'shoebill-attack',
    metadata: {
      frames: {
        'shoebill-attack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-attack-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-attack-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-attack-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-attack-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-attack-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-attack-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill/attack.png',
        size: {
          w: 448,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'shoebill-attack': [
          'shoebill-attack-0',
          'shoebill-attack-1',
          'shoebill-attack-2',
          'shoebill-attack-3',
          'shoebill-attack-4',
          'shoebill-attack-5',
          'shoebill-attack-6',
        ],
      },
    },
  },
  {
    name: 'shoebill-hit',
    metadata: {
      frames: {
        'shoebill-hit-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-hit-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-hit-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-hit-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill/hit.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'shoebill-hit': [
          'shoebill-hit-0',
          'shoebill-hit-1',
          'shoebill-hit-2',
          'shoebill-hit-3',
        ],
      },
    },
  },
  {
    name: 'shoebill-dead',
    metadata: {
      frames: {
        'shoebill-dead-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-dead-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-dead-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-dead-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-dead-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-dead-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'shoebill-dead-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/shoebill/dead.png',
        size: {
          w: 448,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'shoebill-dead': [
          'shoebill-dead-0',
          'shoebill-dead-1',
          'shoebill-dead-2',
          'shoebill-dead-3',
          'shoebill-dead-4',
          'shoebill-dead-5',
          'shoebill-dead-6',
        ],
      },
    },
  },
];
